import React, { useState, useCallback } from "react";
import { graphql, Link } from "gatsby";
import Layout from "../components/layout";
import { ProductPreview } from "../utils/product";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// TODO: Pagination component can be made into a component
// TODO: handle no products. Throws an error if shopify has no products

const Shop = ({
  data: {
    allShopifyProduct: { nodes: products },
  },
  pageContext,
}) => {
  const {
    currentPage,
    numberOfPages,
    data: { categories: collections },
  } = pageContext;
  const [isActive, setIsActive] = useState(false);

  const toggleDropDown = useCallback(() => {
    setIsActive(!isActive);
  }, [isActive]);
  return (
    <Layout>
      <section className="container">
        <nav
          className="level pagination"
          role="navigation"
          aria-label="pagination"
        >
          <div className="level-left">
            <div className="level-item">
              <p className="title is-3">Shop</p>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <div className={isActive ? "dropdown is-active" : "dropdown"}>
                <div className="dropdown-trigger">
                  <button
                    className="button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    onClick={toggleDropDown}
                  >
                    <span>All Collections</span>
                    <span className="icon is-small">
                      <FontAwesomeIcon icon={faAngleDown} />
                    </span>
                  </button>
                </div>
                <div className="dropdown-menu" id="dropdown-menu" role="menu">
                  <div className="dropdown-content">
                    <Link className="dropdown-item is-active" to="/shop">
                      All Collections
                    </Link>
                    {collections.map((c) => (
                      <Link
                        key={`dd-key-${c.handle}`}
                        className="dropdown-item"
                        to={`/shop/${c.handle}`}
                      >
                        {c.title}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="level-item">
                <Link
                  className="pagination-previous"
                  disabled={currentPage === 1}
                  to={`/shop/${currentPage <= 2 ? "" : currentPage - 1}`}
                >
                  Previous
                </Link>
                <Link
                  className="pagination-next"
                  disabled={currentPage === numberOfPages}
                  to={`/shop/${
                    currentPage === numberOfPages ? "" : currentPage + 1
                  }`}
                >
                  Next page
                </Link>
              </div>
            </div>
          </div>
        </nav>
        <div className="tile is-ancestor">
          {products.slice(0, 3).map((p) => (
            <ProductPreview
              key={`product-${p.handle}`}
              product={p}
              slug="/shop"
            />
          ))}
        </div>
        <div className="tile is-ancestor">
          {products.slice(3, 6).map((p) => (
            <ProductPreview
              key={`product-${p.handle}`}
              product={p}
              slug="/shop"
            />
          ))}
        </div>
        <div className="tile is-ancestor">
          {products.slice(6, 9).map((p) => (
            <ProductPreview
              key={`product-${p.handle}`}
              product={p}
              slug="/shop"
            />
          ))}
        </div>
        <div className="tile is-ancestor">
          {products.slice(9, 12).map((p) => (
            <ProductPreview
              key={`product-${p.handle}`}
              product={p}
              slug="/shop"
            />
          ))}
        </div>
        <div className="tile is-ancestor">
          {products.slice(12, 15).map((p) => (
            <ProductPreview
              key={`product-${p.handle}`}
              product={p}
              slug="/shop"
            />
          ))}
        </div>
        <nav
          className="pagination mb-3"
          role="navigation"
          aria-label="pagination"
        >
          <Link
            className="pagination-previous"
            disabled={currentPage === 1}
            to={`/shop/${currentPage <= 2 ? "" : currentPage - 1}`}
          >
            Previous
          </Link>
          <Link
            className="pagination-next"
            disabled={currentPage === numberOfPages}
            to={`/shop/${currentPage === numberOfPages ? "" : currentPage + 1}`}
          >
            Next page
          </Link>
          <ul className="pagination-list">
            {[...Array(numberOfPages).keys()].map((i) => (
              <li key={`paging-li-${i}`}>
                <Link
                  className={`pagination-link ${
                    currentPage === i + 1 ? "is-current" : ""
                  }`}
                  aria-label={
                    i + 1 === currentPage
                      ? `Page ${i + 1}`
                      : `Goto page ${i + 1}`
                  }
                  to={i > 0 ? `/shop/${i + 1}` : "/shop"}
                  aria-current={i + 1 === currentPage ? "page" : ""}
                >
                  {i + 1}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </section>
    </Layout>
  );
};

export const shopQuery = graphql`
  query shopQuery($skip: Int!, $limit: Int!) {
    allShopifyProduct(
      filter: { productType: { nin: ["Classes", "Exhibition Artwork"] } }
      sort: { fields: createdAt, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        handle
        title
        productType
        media {
          preview {
            image {
              gatsbyImageData(layout: CONSTRAINED, width: 512)
            }
          }
        }
        variants {
          shopifyId
          price
          title
        }
      }
    }
  }
`;

export default Shop;
